export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION'
export const NOTIFICATIONS_FETCH_REQUESTED = 'NOTIFICATIONS_FETCH_REQUESTED'
export const GET_LOGGED_IN_USER_FETCH_REQUESTED = 'GET_LOGGED_IN_USER_FETCH_REQUESTED'
export const UPDATE_PAGE_TITLE = 'UPDATE_PAGE_TITLE'
export const UPDATE_PAGE_DESCRIPTION = 'UPDATE_PAGE_DESCRIPTION'
